import BaseModel from 'models/base-model';
import { SocketClient, SOCKET_CONNECTION_TYPE } from 'socket/socketio-client';
import { statementWorkflowsLoaded } from 'store/actions/statement-workflows-actions';
import { NOTIFICATION_EVENT_TYPES } from 'constants/web-socket-constants';
import {
  onCopyStatementSuccess,
  onCopyStatementFailure,
  _isCopyErrorForWrongSourceProject,
  copyErrorNotificationForWrongSourceProject,
} from 'store/actions/statement-list/statement-list-actions';
import {
  getWebSocketNotificationType,
  getWebSocketPayload,
} from 'constants/util/web-socket-utils';
import { toast } from 'react-toastify';
import { updateProjectSocketClient } from 'store/actions/project-socket-actions';
import {
  updateStatementPercentage,
  requestGetStatementList,
} from 'store/actions/common/statement-list-actions';
import { fetchRevisionHistoryBySocketNotification } from 'store/actions/revision-actions';

export default class ProjectSocketModel extends BaseModel({
  client: null,
  socketHasBeenDisconnected: true,
}) {
  init(config) {
    const client = new SocketClient({
      ...config,
      socketConnectionType: SOCKET_CONNECTION_TYPE.PROJECT,
    });
    return this.merge({ ...this, client, socketHasBeenDisconnected: false });
  }

  setProjectSocketClients(dispatch) {
    if (this.client) {
      this.client.on('newMessage', (event) =>
        this.onEventHandler(event, dispatch),
      );
    }
    return this;
  }

  stopProjectSocketConnection() {
    if (this.client) {
      this.client._closeSocketConnection();
      this.client.disconnect();
      return this.merge({ ...this, socketHasBeenDisconnected: true });
    }
    return this;
  }

  setProjectSocketDisconnect(payload) {
    return this.merge({ ...this, socketHasBeenDisconnected: payload });
  }

  onEventHandler = async (event, dispatch) => {
    const webSocketPayload = getWebSocketPayload(event);
    const response = {
      data: webSocketPayload && webSocketPayload.documentProcessWorkflowEntity,
    };
    switch (getWebSocketNotificationType(event)) {
      case NOTIFICATION_EVENT_TYPES.WORKFLOW_STATUS:
        await dispatch(statementWorkflowsLoaded({ response }));
        await dispatch(updateProjectSocketClient({ webSocketPayload }));
        break;
      case NOTIFICATION_EVENT_TYPES.STATEMENT_COPY_SUCCESSFUL:
        await dispatch(onCopyStatementSuccess());
        break;
      case NOTIFICATION_EVENT_TYPES.STATEMENT_ELEMENTS_STATUS_UPDATE:
        if (
          webSocketPayload.statementId != null &&
          Number.isFinite(webSocketPayload.percentageCompleted)
        ) {
          // updateStatementPercentage is a simple action creator (created via createAction), not a thunk.
          // Dispatching it is synchronous, so await is not needed there.
          dispatch(
            updateStatementPercentage({
              statementId: webSocketPayload.statementId,
              percentageCompleted: webSocketPayload.percentageCompleted,
            }),
          );
        } else {
          await dispatch(requestGetStatementList({ withLoading: false }));
        }
        // Refresh revision history to reflect the updated element status in the revision history list only if revision history is already loaded
        // respective to revision history loaded check is added to avoid unnecessary API calls when revision history is not being viewed by the user currently
        await dispatch(
          fetchRevisionHistoryBySocketNotification({
            payload: webSocketPayload,
          }),
        );
        break;
      case NOTIFICATION_EVENT_TYPES.STATEMENT_COPY_FAILED:
        if (_isCopyErrorForWrongSourceProject(webSocketPayload)) {
          toast.error(copyErrorNotificationForWrongSourceProject());
          return;
        }
        await dispatch(onCopyStatementFailure());
        break;
      default:
        break;
    }
  };
}
